var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerSignalMid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2271_2177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 0C37.6739 0 36.4021 0.526784 35.4645 1.46447C34.5268 2.40215 34 3.67392 34 5V35C34 36.3261 34.5268 37.5979 35.4645 38.5355C36.4021 39.4732 37.6739 40 39 40C40.3261 40 41.5979 39.4732 42.5355 38.5355C43.4732 37.5979 44 36.3261 44 35V5C44 3.67392 43.4732 2.40215 42.5355 1.46447C41.5979 0.526784 40.3261 0 39 0V0ZM40.6667 35C40.6667 35.442 40.4911 35.866 40.1785 36.1785C39.866 36.4911 39.442 36.6667 39 36.6667C38.558 36.6667 38.134 36.4911 37.8215 36.1785C37.5089 35.866 37.3333 35.442 37.3333 35V5C37.3333 4.55797 37.5089 4.13405 37.8215 3.82149C38.134 3.50893 38.558 3.33333 39 3.33333C39.442 3.33333 39.866 3.50893 40.1785 3.82149C40.4911 4.13405 40.6667 4.55797 40.6667 5V35Z",
    fill: "#23AA59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.818 1.81802C36.6619 0.974106 37.8065 0.5 39 0.5C40.1935 0.5 41.3381 0.974106 42.182 1.81802C43.0259 2.66193 43.5 3.80653 43.5 5V35C43.5 36.1935 43.0259 37.3381 42.182 38.182C41.3381 39.0259 40.1935 39.5 39 39.5C37.8065 39.5 36.6619 39.0259 35.818 38.182C34.9741 37.3381 34.5 36.1935 34.5 35V5C34.5 3.80653 34.9741 2.66193 35.818 1.81802ZM40.5321 36.5321C40.9384 36.1257 41.1667 35.5746 41.1667 35V5C41.1667 4.42536 40.9384 3.87426 40.5321 3.46794C40.1257 3.06161 39.5746 2.83333 39 2.83333C38.4254 2.83333 37.8743 3.06161 37.4679 3.46794C37.0616 3.87426 36.8333 4.42536 36.8333 5V35C36.8333 35.5746 37.0616 36.1257 37.4679 36.5321C37.8743 36.9384 38.4254 37.1667 39 37.1667C39.5746 37.1667 40.1257 36.9384 40.5321 36.5321Z",
    stroke: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2271_2177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 11C22.6739 11 21.4021 11.5268 20.4645 12.4645C19.5268 13.4021 19 14.6739 19 16V35C19 36.3261 19.5268 37.5979 20.4645 38.5355C21.4021 39.4732 22.6739 40 24 40C25.3261 40 26.5979 39.4732 27.5355 38.5355C28.4732 37.5979 29 36.3261 29 35V16C29 14.6739 28.4732 13.4021 27.5355 12.4645C26.5979 11.5268 25.3261 11 24 11Z",
    fill: "#23AA59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.818 12.818C21.6619 11.9741 22.8065 11.5 24 11.5C25.1935 11.5 26.3381 11.9741 27.182 12.818C28.0259 13.6619 28.5 14.8065 28.5 16V35C28.5 36.1935 28.0259 37.3381 27.182 38.182C26.3381 39.0259 25.1935 39.5 24 39.5C22.8065 39.5 21.6619 39.0259 20.818 38.182C19.9741 37.3381 19.5 36.1935 19.5 35V16C19.5 14.8065 19.9741 13.6619 20.818 12.818Z",
    stroke: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2271_2177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 20C7.67392 20 6.40215 20.5853 5.46447 21.6272C4.52678 22.6691 4 24.0821 4 25.5556V34.4444C4 35.9179 4.52678 37.3309 5.46447 38.3728C6.40215 39.4147 7.67392 40 9 40C10.3261 40 11.5979 39.4147 12.5355 38.3728C13.4732 37.3309 14 35.9179 14 34.4444V25.5556C14 24.0821 13.4732 22.6691 12.5355 21.6272C11.5979 20.5853 10.3261 20 9 20Z",
    fill: "#23AA59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83611 21.9617C6.68508 21.0184 7.82454 20.5 9 20.5C10.1755 20.5 11.3149 21.0184 12.1639 21.9617C13.0144 22.9067 13.5 24.1987 13.5 25.5556V34.4444C13.5 35.8013 13.0144 37.0933 12.1639 38.0383C11.3149 38.9816 10.1755 39.5 9 39.5C7.82454 39.5 6.68508 38.9816 5.83611 38.0383C4.98558 37.0933 4.5 35.8013 4.5 34.4444V25.5556C4.5 24.1987 4.98558 22.9067 5.83611 21.9617Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2271_2177",
    x: 30,
    y: 0,
    width: 18,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2271_2177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2271_2177",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2271_2177",
    x: 15,
    y: 11,
    width: 18,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2271_2177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2271_2177",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2271_2177",
    x: 0,
    y: 20,
    width: 18,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2271_2177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2271_2177",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSignalMid);
export default __webpack_public_path__ + "static/media/powerSignalMid.487aab49def094c97ba56149068da714.svg";
export { ForwardRef as ReactComponent };